import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dimmer,
  Loader
} from 'semantic-ui-react';

import CreateModalWrapper from '_forms/createModal';
import ACTransferForm from '_forms/acTransferInstitution';

import { getACLicenseCode, getACLicensePoolLabel } from '_utils/activationCodes';
import { post } from '_utils/xhr';

const PHASES = {
  FORM: 0,
  SUBMITTING: 1,
  COMPLETE: 2
};

const getInitData = () => ({
  license_pool_id: null
});

const TransferInstACLicenseModal = ({
  license,
  institution,
  onTransfer
}) => {

  const [open, setOpen] = useState(false);
  const [state, setState] = useState({ phase: PHASES.FORM, error: null, message: null });

  const [data, setData] = useState(getInitData());

  const onClose = () => {
    setState({ phase: PHASES.FORM, error: null, message: null });
    setOpen(false);
  };
  const onOpen = () => setOpen(true);

  const onFormChange = (name, value) => {
    const up = Object.assign({}, data, { [name]: value });
    setData(up);
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    setState({ phase: PHASES.SUBMITTING, error: null, message: null });

    const payload = Object.assign({}, data);

    post(
      `/institutions/${encodeURIComponent(institution._id)}/activationcodes/${encodeURIComponent(license.activated_info.ac_id)}/transfer`,
      payload
    )
      .then(lic => {
        setState({ phase: PHASES.COMPLETE, error: null, message: `Successfully transferred license with Activation Code "${getACLicenseCode(license)}" to license pool "${getACLicensePoolLabel(lic)}"` });
        onTransfer(lic);
      })
      .catch(err => setState({ phase: PHASES.FORM, error: err, message: null }));
  };

  return (
    <CreateModalWrapper
      header='Transfer Institution AC License'
      open={ open }
      onClose={ onClose }
      onOpen={ onOpen }
      type='activation code transfer'
      trigger={ <Button positive compact content='Transfer' /> }
    >
      <div>
        <Dimmer inverted active={ state.phase === PHASES.SUBMITTING } >
          <Loader />
        </Dimmer>
        {
          state.phase === PHASES.FORM ? (
            <Fragment>
              <ACTransferForm
                data={ data }
                onChange={ onFormChange }
                onSubmit={ onFormSubmit }
                license={ license }
                institution={ institution }
              />
              {
                state.error ? (
                  <div>
                    Error: <br/>
                    { state.error.message }
                  </div>
                ) : null
              }
            </Fragment>
          ) : null
        }
        {
          state.phase === PHASES.COMPLETE ? (
            <div>
              <div>
                { state.message }
              </div>
              <Button onClick={ onClose }>Close</Button>
            </div>
          ) : null
        }
      </div>
    </CreateModalWrapper>
  );
}

TransferInstACLicenseModal.propTypes = {
  institution: PropTypes.object.isRequired,
  license: PropTypes.object.isRequired,
  onTransfer: PropTypes.func.isRequired
};

export default TransferInstACLicenseModal;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/transferInstACLicenseModal.js